/* fb-pdp — le strict nécessaire, sans dépendance.
   Shrine PRO fournit déjà galerie, variantes, panier et sticky ATC : on ne
   réimplémente rien de tout ça. Ce fichier ne gère que l'accordéon FAQ, et
   uniquement pour fermer les autres items à l'ouverture d'un item — le
   <details> natif fait le reste, y compris sans JS. */
(function () {
  'use strict';
  function initAccordions(root) {
    (root || document).querySelectorAll('[data-fbpdp-accordion]').forEach(function (box) {
      if (box.dataset.fbpdpBound) return;
      box.dataset.fbpdpBound = '1';
      var items = Array.prototype.slice.call(box.querySelectorAll('details'));
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAccordions(); });
  } else {
    initAccordions();
  }
  // L'éditeur de thème réinjecte la section sans recharger la page.
  document.addEventListener('shopify:section:load', function (e) { initAccordions(e.target); });
})();
